import { Client } from '../common';
import { toAvailableCountersPayload, fromAvailableCountersResult, toCountersPayload, fromCountersResult } from './dto';

export async function getAvailableCounters(payload, options = {}, gaVersion) {
  const result = await Client.request({
    method: 'POST',
    url: 'pm-service/availableCounters',
    body: toAvailableCountersPayload(payload),
    ...options
  });

  return fromAvailableCountersResult(result, gaVersion);
}

export async function getCounters(payload, options = {}) {
  const result = await Client.request({
    method: 'POST',
    url: 'pm-service/getCounters',
    body: toCountersPayload(payload),
    ...options
  });

  return fromCountersResult(result, payload);
}
